import { Button } from 'flowbite-react'
import React, {useState} from 'react'
import SubscriptionHistoryWidget from './SubscriptionHistoryWidget'
import { subscription } from '../../../state/useSubscriptionStore';
import CancelSubscriptionPrompt from './cancelSubscriptionPrompt';
import { SidebarDrawer } from '../../common';
import { Link } from 'react-router-dom';

interface SubscriptionPlanProps {
  subscriptionState: subscription | null
}

const SubscriptionPlan = ({subscriptionState}: SubscriptionPlanProps) => {
   
  return (
    <div className='w-full big:w-[1/2]'>
     <p className='text-[14px] sm:text-[16px] whitespace-nowrap'>Your Next Subscription Plan Date is <span className='text-[#FB0303] text-[14px] sm:text-[16px] sm:ml-[8px]' style={{fontWeight: 600}}>{new Date(subscriptionState?.nextDate as unknown as Date).toDateString()}</span></p> 
     
     <div className='bg-[#EDF2F5] rounded-[4px] w-full lg:h-[193px] flex gap-[30px] pb-[31px] flex-col justify-between px-[12px] md:px-[30px] pt-[36.5px] mt-[12px]'>
         <div className='flex flex-row justify-between items-center'>
            <p className='text-[#212121] text-[16px]' style={{fontWeight: 600}}>{subscriptionState?.plan ? subscriptionState.plan : "No Active Plan"}</p>
            <p> <span className='text-[#212121] text-[16px] lg:text-[30px]' style={{fontWeight: 600}}>{subscriptionState?.costPerMonth}</span>/month</p>
         </div>
        
       <div className='flex flex-row justify-between items-center'>
        <SubscriptionHistoryWidget subscriptionData={subscriptionState}/>
        <Link to={"/subscription"}>
         <button className='border border-[#044E97] rounded-[4px] py-[11px] px-[13px] md:py-[16px] md:px-[34px] text-[#044E97] text-[16px] whitespace-nowrap' style={{fontWeight: 600}}>
              Choose Plan
          </button>
        </Link>
        
       </div>

     </div>


     
     
   
   
    </div>
  )
}

export default SubscriptionPlan